import { render, staticRenderFns } from "./EntityTable.vue?vue&type=template&id=b5e38f18&scoped=true&"
import script from "./EntityTable.vue?vue&type=script&lang=js&"
export * from "./EntityTable.vue?vue&type=script&lang=js&"
import style0 from "./EntityTable.vue?vue&type=style&index=0&id=b5e38f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e38f18",
  null
  
)

export default component.exports